import { combineReducers } from 'redux'

import filtro from './filtro'
import filtroAplicados from './filtroAplicados'
import resultados from './consultaDespesasCartaoCorporativo'

export default combineReducers({ filtro, filtroAplicados, resultados })
